// extracted by mini-css-extract-plugin
export default {"screen":"NotFound_screen__PLNaK"};